module.exports = __webpack_public_path__ + "static/media/dataStructureOperations.3202b34e.png";